const SOCKET_CONSTANTS = {
    CLIENT_SEND_FORM: 'CLIENT_SEND_FORM',
    SERVER_SEND_FORM_ERROR: 'SERVER_SEND_FORM_ERROR',
    SERVER_SEND_ACS_DATA: 'SERVER_SEND_ACS_DATA',
    PAYMENT_CHANGED_STATUS: 'PAYMENT_CHANGED_STATUS',
    SET_INITIAL_DATA: 'SET_INITIAL_DATA'
};

export {
    SOCKET_CONSTANTS
}
